<template>
	<div>
		<!-- <searchForm ref="MyTerm" @show="show" ></searchForm> -->
		<div class="demo-split">
			<Split v-model="split1">
				<div slot="left" class="demo-split-pane">
					<LeftForm ref="MyTermFile" @show="show" @handleSubmitFile="handleSubmitFile" @delFile="delFile">
					</LeftForm>
					<Table ref="currentRowTable" :columns="columnsFile" :data="Filedata" :height="tableHeight"></Table>
					<MyPage ref="sonPageFile" :param="SelectParamFile" :url="getUpgradeFilesUrl"
						@listData='getFileList'></MyPage>
				</div>
				<div slot="right" class="demo-split-pane">
					<RightForm ref="MyTermList" @show="show" @handleSubmitList="handleSubmitList" @Upgrade='Upgrade'>
					</RightForm>
					<Table @on-selection-change="selectChangeList" :columns="columnsList" :data="Listdata"
						:height="tableHeight"></Table>
					<MyPage ref="sonPageList" :param="SelectParamList" :url="getEquipmentInfoUrl"
						@listData='getDeviceList'></MyPage>
				</div>
			</Split>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi';
	import searchForm from './Template/RemoteUpgradeForm.vue';
	import LeftForm from './Template/RemoteUpgradeFormLeft.vue';
	import RightForm from './Template/RemoteUpgradeFormRight.vue';
	import FileModal from './Template/UpgradeFileModal.vue';
	import ListModal from './Template/UpgradeListModal.vue';
	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			searchForm,
			LeftForm,
			RightForm
			// DistributeModal
		},
		data() {
			return {
				getUpgradeFilesUrl: webapi.base_api_url + '/System/GetUpgradeFiles',
				getEquipmentInfoUrl: webapi.base_api_url + '/System/GetEquipmentInfo',
				//面板分割线
				split1: 0.4,
				//查询组件的参数
				SelectParam: {},
				SelectParamFile: {},
				SelectParamList: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['系统管理', '>>', '控件管理'],
				Flag: 'File',
				//table标题数据
				columnsFile: [{
						title: '选择',
						key: 'id',
						width: 70,
						align: 'center',
						render: (h, params) => {
							let id = params.row.Id;
							let flag = false;
							if (this.selectedFileId === id) {
								flag = true
							}
							let self = this
							return h('div', [
								h('Radio', {
									props: {
										value: this.selectedFileId === id,
									},
									on: {
										'on-change': () => {
											self.selectedFileId = id;
										}
									}
								})
							])
						}
					}, {
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '文件名',
						key: 'FileName',
					},
					// {
					// 	title: '文件大小',
					// 	key: 'FileSize',
					// },
					{
						title: '版本',
						key: 'FileVersion',
					},
					// {
					// 	title: '校验',
					// 	key: 'FileVerify',
					// },
					{
						title: '上传时间',
						key: 'UploadTime',
					},
				],
				columnsList: [{
						type: 'selection',
						width: 60,
						align: 'center'
					},
					{
						title: '设备编号',
						key: 'EquipmentNo',
					}, {
						title: '设备类型',
						key: 'EquipmentType',
						render: (h, params) => {
							return h('div', params.row.EquipmentTypeDesc)
						}
					}, {
						title: '设备型号',
						key: 'EquipmentModel',
					}, {
						title: '设备状态',
						key: 'EquipmentStatus',
						render: (h, params) => {
							return h('div', params.row.EquipmentStatusDesc)
						}
					}, {
						title: '程序版本',
						key: 'SoftVersion',
						sortable: true
					}, {
						title: '场站名',
						key: 'StationName',
					}, {
						title: '操作状态',
						key: 'Code',
					}, {
						title: '操作消息',
						key: 'Msg',
					},
				],
				Filedata: [],
				Listdata: [],
				selectedFileId: '',
				selectedListId: []
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 300;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			//this.SelectParam = this.$refs.MyTerm.formInline
			this.SelectParamList = this.$refs.MyTermList.formInline
			//this.SelectParamFile = this.$refs.MyTermFile.formInline
			this.$nextTick(() => {
				this.handleSubmitFile();
				this.handleSubmitList();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			selectChangeList: function(EquipmentList) {
				this.selectedListId = EquipmentList.map(function(Equipment) {
					console.log(Equipment.EquipmentNo);
					return Equipment.EquipmentNo;
				})
			},
			selectChangeFile: function(currentRow, oldCurrentRow) {
				this.selectedFileId === currentRow.Id
			},
			Upgrade: function() {
				const _this = this
				if (_this.selectedFileId == '') {
					_this.$Message.error("请点击文件列表选择升级文件")
				} else if (_this.selectedListId.length == 0) {
					_this.$Message.error("请点击设备列表选择升级设备")
				} else {
					let MyListdata1 = []
					_this.Listdata.map(function(resItem) {
						_this.selectedListId.map(function(item) {
							if (item == resItem.EquipmentNo) {
								resItem.Code = -2
								resItem.Msg = '请等待'
							}
						})
						MyListdata1.push(resItem)
					})
					_this.Listdata = MyListdata1
					let params = {
						UpgradeFileId: _this.selectedFileId,
						List: _this.selectedListId,
						FtpParams: this.$refs.MyTermFile.formInline,
					}
					_this.$axios.post(webapi.base_api_url + "/System/EquipmentUpgrade", params).then(res => {
						if (res.data.Code == 0) {
							//_this.handleSubmitList()
							//_this.handleSubmitFile()
							let MyListdata = []
							console.log(_this.Listdata);
							_this.Listdata.map(function(resItem) {
								console.log(resItem);
								res.data.Data.map(function(item) {
									console.log(resItem.EquipmentNo)
									console.log(item.EquipmentNo)
									if (resItem.EquipmentNo == item.EquipmentNo) {
										resItem.Code = item.Code
										resItem.Msg = item.Msg
									}
								})
								MyListdata.push(resItem)
							})
							console.log(MyListdata);
							_this.Listdata = MyListdata
						}
					})
					//_this.selectedFileId = '';
					_this.selectedListId = [];
					_this.$refs.currentRowTable.clearCurrentRow();
				}
			},
			delFile: function() {
				const _this = this
				if (_this.selectedFileId == '') {
					_this.$Message.error("请点击文件列表选择要删除的文件")
				} else {
					let params = {
						UpgradeFileId: _this.selectedFileId
					}
					_this.$axios.post(webapi.base_api_url + "/System/DeleteFileById", params).then(res => {
						if (res.data.Code == 0) {
							_this.handleSubmitList()
							_this.handleSubmitFile()
							this.$Message.info('文件删除成功');
						}
					})
				}
				_this.selectedFileId = '';
				_this.$refs.currentRowTable.clearCurrentRow();
			},
			// //删除修改之外的其他操作
			// otherMethodStation: function(name, Id) {
			// 	let typeNum = (this.methodList.filter(function(item, index, arr) {
			// 		return item.Status == name
			// 	})[0]).Id
			// 	this.$axios.post(webapi.base_api_url + "/System/SetSysWidgetStatus ", {
			// 		Id: Id,
			// 		Status: typeNum
			// 	}).then(res => {
			// 		if (res.data.Code == 0) {
			// 			this.$Message.info(name + '成功');
			// 			this.handleSubmit();
			// 		}
			// 	})
			// },
			/******************组件固定方法*************************/
			show: function(type, params) {
				switch (type) {
					case 'up':
						this.$refs.ItemModal.show(type, params)
						break;
					case 'add':
						this.$refs.ItemModal.show(type, params)
						break;
						// case 'distribute':
						// this.$refs.DistributeModal.show(type, params)
						// break;
				}
			},
			getDeviceData: function(data) {
				this.Filedata = data.Data.List
			},
			getFileList: function(data) {
				this.Filedata = data.Data.List
			},
			getDeviceList: function(data) {
				this.Listdata = data.Data.List
			},
			handleSubmitList: function() {
				this.$refs.sonPageList.getList("deviceList");
			},
			handleSubmitFile: function() {
				this.$refs.sonPageFile.getList("fileList");
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
		},
	}
</script>

<style>
	.ivu-table-row-highlight td {
		background-color: #00FFFF;
	}
</style>
